/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentSessionDto } from '../../models/agent-session-dto';

export interface GetnotificationsAgentSessionUpdatedSchema$Params {
}

export function getnotificationsAgentSessionUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsAgentSessionUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentSessionDto>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsAgentSessionUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentSessionDto>;
    })
  );
}

getnotificationsAgentSessionUpdatedSchema.PATH = '/api/hubs/notifications/AgentSessionUpdated';
